'use client';

import { Minus, Plus } from 'lucide-react';
import { useEffect, useId, useRef, useState } from 'react';

import { clsx } from 'clsx';

import { QuestionItemType } from '../../../model/types/faqPageData';
import cls from './QuestionItem.module.scss';

type QuestionItemProps = {
  data: Pick<QuestionItemType, 'title' | 'text'>;
  id?: string;
};

export const QuestionItem = ({ data, id }: QuestionItemProps) => {
  const generatedId = useId();
  const contentId = `${id || generatedId}-section`;
  const triggerId = `${id || generatedId}-trigger`;
  const ref = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const onChange = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (isOpen) {
      ref.current.style.maxHeight = ref.current.scrollHeight + 'px';
    } else {
      ref.current.style.maxHeight = '0';
    }
  }, [isOpen]);

  return (
    <div className={clsx(cls.wrap, { [cls.active]: isOpen })}>
      <button
        aria-expanded={isOpen}
        id={triggerId}
        aria-controls={contentId}
        onClick={onChange}
        className={cls.trigger}
      >
        <span>{data.title}</span>
        <span className={cls.circle}>
          <Plus
            className={cls.plus}
            color={'#fff'}
          />
          <Minus
            className={cls.minus}
            color={'#fff'}
          />
        </span>
      </button>

      <div
        ref={ref}
        id={contentId}
        aria-labelledby={triggerId}
        className={cls.content}
        role={'region'}
      >
        {data.text && (
          <div
            className={cls.text}
            dangerouslySetInnerHTML={{ __html: data.text }}
          />
        )}
      </div>
    </div>
  );
};
